module.exports = __webpack_public_path__ + "static/media/prize-tray.92246b99.png";